import { createDraftContext } from '../../context'

export const RentalPortalListingDraft = createDraftContext()
